export default {
  primary:
    "h-[40px] flex items-center justify-center gap-1.5 bg-primary hover:bg-primary_hov text-text_inv font-bold rounded-full py-2 px-4 transition-colors ease-in-out",

  secondary:
    "h-[40px] flex items-center justify-center gap-1.5 border border-bordered text-text hover:border-text hover:text-text font-bold rounded-full py-2 px-4 transition-colors ease-in-out",

  secondary_red:
    "h-[40px] flex items-center justify-center gap-1.5 border border-error text-error hover:bg-error hover:text-white font-bold rounded-full py-2 px-4 transition-colors ease-in-out",

  admin_primary:
    "h-[40px] flex items-center justify-center gap-1.5 bg-admin_primary hover:bg-admin_primary_dk text-white font-bold rounded-full py-2 px-4 transition-colors ease-in-out disabled:opacity-50",

  admin_primary_red:
    "h-[40px] flex items-center justify-center gap-1.5 bg-admin_error/90 hover:bg-admin_error text-white font-bold rounded-full py-2 px-4 transition-colors ease-in-out disabled:opacity-50",

  admin_store: "w-[250px] flex items-center justify-center rounded-md py-5 px-5",

  admin_secondary: "h-[40px] flex items-center justify-center gap-1.5 border border-admin_primary text-admin_primary hover:text-white hover:bg-admin_primary font-bold rounded-full py-2 px-4 transition-colors disabled:opacity-50",

  admin_icon: "h-[40px] flex items-center justify-center border-0 font-bold py-2 px-4 rounded hover:text-admin_primary transition-colors shrink-0 disabled:opacity-50",

  admin_user_settings:
    "w-full h-full flex items-center bg-transparent text-admin_text hover:text-admin_link hover:font-bold",

  admin_social_connect: "h-[40px] flex items-center justify-center text-white font-bold py-2 px-4 rounded-full",

  admin_viewer_controls:
    "h-[40px] flex items-center justify-center text-admin_text hover:text-white text-sm font-bold px-3 py-1 bg-admin_neutral_1 hover:bg-admin_neutral_2 rounded-full",

  admin_viewer_controls_small:
    "h-[28px] flex items-center justify-center text-admin_text text-sm font-bold px-3 py-1 bg-admin_neutral_1 hover:bg-admin_neutral_2 rounded",

  admin_error: "h-[40px] flex items-center justify-center gap-1.5 border-solid border border-admin_error text-admin_error hover:text-white hover:bg-admin_error font-bold rounded-full py-2 px-4 transition-colors disabled:opacity-50",

  admin_text: "flex items-center justify-center gap-1.5 text-admin_primary hover:underline font-medium px-2 py-1 transition-all ease-in-out",

  admin_text_warning: "text-admin_warning hover:bg-admin_warning/5 underline font-medium cursor-pointer rounded-full py-2 px-4 transition-all duration-200 ease-in-out",

  // Sign-in provider / email buttons: full-width stacked pills. The caller appends
  // a background class (bg-[#4285F4], bg-gray-900, bg-primary, …) and, for the
  // light "default" provider case, a text-text override.
  sign_in_option:
    "w-full h-[48px] flex items-center justify-center gap-3 rounded-full px-4 font-bold text-white transition-colors ease-in-out",

  sign_in_option_disabled:
    "w-full h-[48px] flex items-center justify-center gap-3 rounded-full px-4 font-bold text-white/70 cursor-not-allowed transition-colors ease-in-out",
}
